<template>
<div>
    <!-- Catalogos Cliente -->
    <v-menu v-if="es_analytics && menu_catalogos" bottom nav offset-y origin="center center" transition="scale-transition">
        <template v-slot:activator="{ attrs, on }">
            <v-btn text v-on="on" :title="fullWidth < 1024?'Catálogos':''" :icon="fullWidth <= 1024">
                <v-icon>list</v-icon>
                <span class="caption">Catálogos</span>
            </v-btn>
        </template>
        <v-list :tile="false" nav>
            <app-bar-item v-if="valida_permiso('catalogos.embarques') " to="/catalogos/emisores_destinatarios" @click.shift="openNew('/catalogos/emisores_destinatarios');">

                <v-icon>mdi-circle-small</v-icon>Emisores/Destinatarios

            </app-bar-item>

            <app-bar-item v-if="valida_permiso('catalogos.emisores') " to="/catalogos/embarcadores" @click.shift="openNew('/catalogos/embarcadores');">

                <v-icon>mdi-circle-small</v-icon>Embarcadores/Consignatarios

            </app-bar-item>

            <app-bar-item v-if="valida_permiso('catalogos.transportistas')" to="/catalogos/transportistas" @click.shift="openNew('/catalogos/transportistas');">

                <v-icon>mdi-circle-small</v-icon>Transportistas

            </app-bar-item>

            <app-bar-item v-if="valida_permiso('catalogos.agentes.aduanales') " to="/catalogos/agentes" @click.shift="openNew('/catalogos/agentes');">

                <v-icon>mdi-circle-small</v-icon>Agentes Aduanales

            </app-bar-item>

            <app-bar-item v-if="valida_permiso('catalogos.representantes')" to="/catalogos/representantes" @click.shift="openNew('/catalogos/representantes');">

                <v-icon>mdi-circle-small</v-icon>Representantes Legales

            </app-bar-item>

            <app-bar-item v-if="valida_permiso('Reportes.personalizados.referencias') && view_trafico==0 && view_costing==0" to="/catalogos/referencias" @click.shift="openNew('/catalogos/referencias');">

                <v-icon>mdi-circle-small</v-icon>Planta-Referencia

            </app-bar-item>

        </v-list>
    </v-menu>

    <!-- Utilerias -->
    <v-menu v-if="es_analytics &&  menu_utilerias" nav bottom offset-y origin="center center" transition="scale-transition">
        <template v-slot:activator="{ attrs, on }">
            <v-btn text v-on="on" :icon="fullWidth <= 1024" :title="fullWidth < 1024?'Utilerias':''" v-tippy>
                <v-icon>dashboard</v-icon>
                <span class="caption" v-show="fullWidth > 1024">Utilerías</span>
            </v-btn>
        </template>
        <v-list :tile="false" nav>
            <app-bar-item v-if="valida_permiso('administracion.usuarios')" to="/catalogos/usuarios" @click.shift="openNew('/catalogos/usuarios');">

                <v-icon>mdi-circle-small</v-icon>Usuarios

            </app-bar-item>

            <app-bar-item v-if="valida_permiso('administracion.aduanas') && !soloEcosting" to="/clientes/aduanas" @click.shift="openNew('/clientes/aduanas');">

                <v-icon>mdi-circle-small</v-icon>Aduanas Cliente

            </app-bar-item>

            <app-bar-item v-if="valida_permiso('administracion.apendices') && !soloEcosting" to="/apendices/24" @click.shift="openNew('/apendices/24');">

                <v-icon>mdi-circle-small</v-icon>Apéndices

            </app-bar-item>

            <app-bar-item v-if="valida_permiso('administracion.accesos')" to="/catalogos/acceso_usuarios" @click.shift="openNew('/catalogos/acceso_usuarios');">

                <v-icon>mdi-circle-small</v-icon>Log de Accesos

            </app-bar-item>
            <app-bar-item v-if="valida_permiso('administracion.enotes')" to="/catalogos/enotes" @click.shift="openNew('/catalogos/enotes');">

                <v-icon>mdi-circle-small</v-icon>eNotes

            </app-bar-item>

            <v-divider v-if="view_trafico==0  && view_costing==0 && valida_permiso('administracion.indicadores') && valida_permiso('administracion.configurables')" />

            <app-bar-item v-if="valida_permiso('administracion.indicadores') && view_trafico==0  && view_costing==0" class="font-weight-thin" to="/utilerias/indicadores" @click.shift="openNew('/utilerias/indicadores');">

                <v-icon x-small>mdi-circle-small</v-icon>&nbsp; Indicadores Especiales

            </app-bar-item>

            <app-bar-item v-if="valida_permiso('administracion.configurables') && view_trafico==0 && view_costing==0" to="/utilerias/configurables" @click.shift="openNew('/utilerias/configurables');" class="font-weight-thin">

                <v-icon x-small>mdi-circle-small</v-icon>&nbsp; Configurables

            </app-bar-item>

            <app-bar-item v-if="this.$local_storage.get('tipo_usuario') == 'Super Usuario' && valida_permiso('Anexo24.reportes')  && view_trafico==0 && view_costing==0" @click.native="hideMenuReportes" to="/utilerias/cargaa24" @click.shift="openNew('/utilerias/cargaa24');">
                <v-icon>mdi-circle-small</v-icon>Cargar Reportes Anexo 24
            </app-bar-item>
        </v-list>
    </v-menu>

    <!-- Vucem-Transmision -->
    <v-menu v-if="es_analytics &&  menu_transmision && view_trafico==0 && view_costing==0 && view_emanifiesto == 0" nav bottom offset-y origin="center center" transition="scale-transition">
        <template v-slot:activator="{ attrs, on }">
            <v-btn :icon="fullWidth <= 1024" :title="fullWidth < 1024?'Vucem-Transmision':''" v-on="on" v-tippy text>
                <v-icon>launch</v-icon>
                <span class="caption">Vucem-Transmisión</span>
            </v-btn>
        </template>
        <v-list :tile="false" nav>
            <app-bar-item v-if="valida_permiso('VUCEM.Transmision.nuevo.cove')" to="/transmision/cove" @click.shift="openNew('/transmision/cove');">

                <v-icon>mdi-circle-small</v-icon>Nuevo Cove

            </app-bar-item>

            <app-bar-item v-if="valida_permiso('VUCEM.Transmision.ver.coves')" to="/transmision/covedetalles" @click.shift="openNew('/transmision/covedetalles');">

                <v-icon>mdi-circle-small</v-icon>Ver Coves

            </app-bar-item>

            <app-bar-item v-if="valida_permiso('VUCEM.Transmision.nuevo.edocument') || valida_permiso('VUCEM.Transmision.ver.edocument')" to="/transmision/edocument" @click.shift="openNew('/transmision/edocument');">

                <v-icon>mdi-circle-small</v-icon>E-Document

            </app-bar-item>

            <app-bar-item v-if="valida_permiso('VUCEM.Transmision.reporte.coves')" to="/reportes/transmitted_coves" @click.shift="openNew('/reportes/transmitted_coves');">

                <v-icon>mdi-circle-small</v-icon>Reportes de COVES Transmitidos

            </app-bar-item>

            <app-bar-item v-if="valida_permiso('VUCEM.Transmision.reporte.edocument')" to="/reportes/transmitted_edocs" @click.shift="openNew('/reportes/transmitted_edocs');">

                <v-icon>mdi-circle-small</v-icon>Reportes de Digitalizados Transmitidos

            </app-bar-item>
            <v-divider />
            <app-bar-item @click.native="downloadFile('COVE_DiccionarioDeDatos.pdf');">

                <v-icon>mdi-circle-small</v-icon>Diccionario de COVE

            </app-bar-item>

        </v-list>
    </v-menu>

    <!-- Data Stage -->
    <v-menu v-if="es_analytics &&  menu_datastage && view_trafico==0 && view_costing==0 && view_emanifiesto == 0" bottom nav offset-y origin="center center" transition="scale-transition">
        <template v-slot:activator="{ attrs, on }">
            <v-btn text :icon="fullWidth <= 1024" :title="fullWidth < 1024?'Data Stage':''" v-on="on" v-tippy>
                <v-icon>attach_file</v-icon>
                <span class="caption" v-show="fullWidth > 1024">Data Stage</span>
            </v-btn>
        </template>
        <v-list :tile="false" nav>
            <app-bar-item v-if="valida_permiso('DATA.STAGE.cargazip')" to="/datastage/cargazip" @click.shift="openNew('/datastage/cargazip');">

                <v-icon>mdi-circle-small</v-icon>Carga Zip

            </app-bar-item>

            <app-bar-item v-if="valida_permiso('DATA.STAGE.bitacora')" to="/datastage/bitacorazip" @click.shift="openNew('/datastage/bitacorazip');">

                <v-icon>mdi-circle-small</v-icon>Bitácora ZIP

            </app-bar-item>
            <app-bar-item v-if="valida_permiso('DATA.STAGE.reportesdirectos')" to="/datastage/directo_ds" @click.shift="openNew('/datastage/directo_ds');">

                <v-icon>mdi-circle-small</v-icon>Reportes Directos DS

            </app-bar-item>

            <v-divider />
            <app-bar-item @click.native="downloadFile('ManualConsultaDataStage.pdf');">

                <v-icon>mdi-circle-small</v-icon>Manual Consulta DS

            </app-bar-item>
        </v-list>
    </v-menu>

    <!-- Vucem-Pedimento -->
    <v-menu v-if="es_analytics &&  menu_vucem" bottom nav offset-y origin="center center" transition="scale-transition">
        <template v-slot:activator="{ attrs, on }">
            <v-btn text :icon="fullWidth <= 1024" :title="fullWidth < 1024?'Vucem-Pedimento':''" v-on="on" v-tippy>
                <v-icon>swap_vert</v-icon>
                <span class="caption" v-show="fullWidth > 1024">Vucem-Pedimento</span>
            </v-btn>
        </template>

        <v-list :tile="false" nav>
            <app-bar-item v-if="valida_permiso('VUCEM.Pedimento.solicitud.consulta')" to="/vucem/layout" @click.shift="openNew('/vucem/layout');">

                <v-icon>mdi-circle-small</v-icon>Solicitud de Consulta

            </app-bar-item>

            <app-bar-item v-if="false && valida_permiso('VUCEM.Pedimento.consulta.diaria')" to="/vucem/diaria" @click.shift="openNew('/vucem/diaria');">

                <v-icon>mdi-circle-small</v-icon>Programar Consulta Diaria

            </app-bar-item>
            <!--    <app-bar-item v-if="valida_permiso('VUCEM.Pedimento.consulta.soia')" to="/vucem-pedimento/qr" @click.shift="openNew('/vucem-pedimento/qr');">

                    <v-icon>mdi-circle-small</v-icon>Consulta Rápida SOIA

                </app-bar-item> -->
            <v-menu v-if="valida_permiso('VUCEM.Pedimento.consulta.soia')" open-on-hover offset-x nav transition="scale-transition">
                <template v-slot:activator="{ attrs, on }">

                    <span v-on="on" id="menuSoia">
                        <app-bar-item @click.native="hideMenuReportes">

                            <v-icon x-small>mdi-circle-small</v-icon>&nbsp; Consulta Rápida SOIA
                            <v-icon>mdi-menu-right</v-icon>
                        </app-bar-item>
                    </span>
                </template>
                <v-list :tile="false" nav>
                    <app-bar-item @click.native="hideMenuReportes" to="/vucem-pedimento/qr">
                        <v-icon>mdi-circle-small</v-icon>Consulta Rapida
                    </app-bar-item>
                    <app-bar-item @click.native="linkConsultaRapida">
                        <v-icon>mdi-circle-small</v-icon>Detalle de Cruce o Módulo del Despacho
                    </app-bar-item>

                </v-list>
            </v-menu>
      <v-menu v-if="valida_permiso('VUCEM.Pedimento.consulta.estado')" open-on-hover offset-x nav transition="scale-transition">
                <template v-slot:activator="{ attrs, on }">

                    <span v-on="on" id="menuEstados">
                        <app-bar-item @click.native="hideMenuReportes">

                            <v-icon x-small>mdi-circle-small</v-icon>&nbsp; Estado de Pedimento
                            <v-icon>mdi-menu-right</v-icon>
                        </app-bar-item>
                    </span>
                </template>
                <v-list :tile="false" nav>
                    <app-bar-item v-if="valida_permiso('VUCEM.Pedimento.consulta.estado')" to="/reportes/consultar_estados_ws" @click.native="hideMenuReportes" @click.shift="openNew('/reportes/consultar_estados_ws');">

                        <v-icon>mdi-circle-small</v-icon>WS

                        </app-bar-item>
                    <app-bar-item v-if="valida_permiso('VUCEM.Pedimento.consulta.soia')" class="font-weight-thin" to="/vucem/estados_soia" @click.native="hideMenuReportes" @click.shift="openNew('/vucem/estados_soia');">
                        <v-icon>mdi-circle-small</v-icon>SOIA
                    </app-bar-item>

                </v-list>
            </v-menu>
            <app-bar-item v-if="valida_permiso('VUCEM.Pedimento.linea.captura')" class="font-weight-thin" to="/vucem/lineas" @click.shift="openNew('/vucem/lineas');">
                <v-icon>mdi-circle-small</v-icon>Pago Referenciado
            </app-bar-item>

            <v-divider />

            <v-icon>mdi-menu-right</v-icon><strong>INFORMACIÓN DE CONSULTA WS</strong>
            <app-bar-item v-if="valida_permiso('VUCEM.Pedimento.consulta.pedimento')" to="/reportes/consultar_pedimentos_detalle" @click.shift="openNew('/reportes/consultar_pedimentos_ws');">

                <v-icon>mdi-circle-small</v-icon>Pedimentos

            </app-bar-item>
            <app-bar-item v-if="valida_permiso('VUCEM.Pedimento.consulta.cove')" to="/reportes/consultar_coves_ws" @click.shift="openNew('/reportes/consultar_coves_ws');">

                <v-icon>mdi-circle-small</v-icon>COVE

            </app-bar-item>

            <app-bar-item v-if="valida_permiso('VUCEM.Pedimento.consulta.edocument')" to="/reportes/consultar_edocuments_ws" @click.shift="openNew('/reportes/consultar_edocuments_ws');">

                <v-icon>mdi-circle-small</v-icon>E-Document

            </app-bar-item>

            <app-bar-item v-if="valida_permiso('VUCEM.Pedimento.consulta.cove')" to="/reportes/consultar_remesas_ws" @click.shift="openNew('/reportes/consultar_remesas_ws');">

                <v-icon>mdi-circle-small</v-icon>Remesas

            </app-bar-item>

            <app-bar-item v-if="valida_permiso('VUCEM.Pedimento.consulta.acuses')" to="/reportes/consultar_acuses_ws" @click.shift="openNew('/reportes/consultar_acuses_ws');">

                <v-icon>mdi-circle-small</v-icon>Acuses

            </app-bar-item>
              <app-bar-item v-if="valida_permiso('VUCEM.Pedimento.consulta.pedimento')" to="/reportes/consultar_pedimentos_manifestacion" @click.shift="openNew('/reportes/consultar_pedimentos_manifestacion');">
                <v-icon>mdi-circle-small</v-icon>Manifestación de Valor
            </app-bar-item>
            <v-divider />

       

            <app-bar-item v-if="valida_permiso('VUCEM.Pedimento.reportes.directos')" to="/vucem/directo_ws" @click.shift="openNew('/vucem/directo_ws');">
                <v-icon>mdi-circle-small</v-icon>Reporte Secciones Pedimento WS
            </app-bar-item>



            <v-divider />
            <app-bar-item @click.native="downloadFile('ManualConsultaDiccionarioPedimento.pdf');">

                <v-icon>mdi-circle-small</v-icon>Manual Consulta Pedimentos

            </app-bar-item>
        </v-list>
    </v-menu>

    <!-- Edrive -->
    <v-menu v-if="es_analytics &&  menu_edrive " bottom offset-y origin="center center" nav transition="scale-transition">
        <template v-slot:activator="{ attrs, on }">
            <v-btn text v-on="on" :icon="fullWidth <= 1024" :title="fullWidth < 1024?'eDrive':''" v-tippy >
                <v-icon>account_tree</v-icon>
                <span class="caption" v-show="fullWidth > 1024">E-Drive</span>
            </v-btn>
        </template>
        <v-list :tile="false" nav>
            <app-bar-item v-if="valida_permiso('eDrive.consulta.expediente')" to="/edrive/explorer" @click.shift="openNew('/edrive/explorer');">
                <v-icon>mdi-circle-small</v-icon>Consultar Expediente
            </app-bar-item>

            <app-bar-item v-if="valida_permiso('eDrive.descargar.expediente')" to="/expediente_pedimento" @click.shift="openNew('/expediente_pedimento');">
                <v-icon>mdi-circle-small</v-icon>Descargar Expediente
            </app-bar-item>

            <v-divider />
            <v-menu v-if="(valida_permiso('eDrive.carga.zip') || valida_permiso('eDrive.bandeja.temporal') || valida_permiso('eDrive.consulta.adjuntos')) && view_trafico==0" open-on-hover offset-x nav transition="scale-transition">
                <template v-slot:activator="{ attrs, on }">
                    <span v-on="on" id="menuAdjuntos">
                        <app-bar-item>

                            <v-icon>mdi-circle-small</v-icon>Adjuntos a Expediente<v-icon>mdi-menu-right</v-icon>

                        </app-bar-item>
                    </span>
                </template>

                <v-list :tile="false" nav>
                    <app-bar-item @click.native="hideMenuReportes" v-if="valida_permiso('eDrive.carga.zip')" to="/cargar_adjuntos_pedimento" @click.shift="openNew('/cargar_adjuntos_pedimento');">
                        <v-icon>mdi-circle-small</v-icon>Carga Adjuntos a Expediente
                    </app-bar-item>
                    <app-bar-item @click.native="hideMenuReportes" v-if="valida_permiso('eDrive.carga.zip')" to="/vucem/adjuntar_edocument" @click.shift="openNew('/vucem/adjuntar_edocument');">
                        <v-icon>mdi-circle-small</v-icon>Adjuntar eDocuments
                    </app-bar-item>

                    <app-bar-item @click.native="hideMenuReportes" v-if="valida_permiso('eDrive.bandeja.temporal') " to="/bandeja_temporal" @click.shift="openNew('/bandeja_temporal');">
                        <v-icon>mdi-circle-small</v-icon>Expediente en Proceso
                    </app-bar-item>

                    <app-bar-item @click.native="hideMenuReportes" v-if="valida_permiso('eDrive.consulta.adjuntos')" to="/consulta_adjuntos" @click.shift="openNew('/consulta_adjuntos');">
                        <v-icon>mdi-circle-small</v-icon>Consulta Archivos Adjuntos
                    </app-bar-item>
                </v-list>
            </v-menu>
            <v-menu v-if="valida_permiso('eDrive.activofijo') && view_trafico==0 && view_costing==0" open-on-hover offset-x nav transition="scale-transition">
                <template v-slot:activator="{ attrs, on }">

                    <span v-on="on" id="menuPermisosPrevios">
                        <app-bar-item @click.native="hideMenuReportes">

                            <v-icon>mdi-circle-small</v-icon><span style="text-transform: capitalize!important;">Activo Fijo CE</span>
                            <v-icon>mdi-menu-right</v-icon>
                        </app-bar-item>
                    </span>
                </template>
                <v-list :tile="false" nav>
                    <app-bar-item @click.native="hideMenuReportes" to="/reportes/informacion_activo">
                        <v-icon>mdi-circle-small</v-icon>Información de Contenido de Pedimentos
                    </app-bar-item>
                    <v-divider />
                    <app-bar-item @click.native="hideMenuReportes" to="/reportes/layouts_activofijo">
                        <v-icon>mdi-circle-small</v-icon>Interfaz de Identificación AF_FILE
                    </app-bar-item>

                    <app-bar-item @click.native="hideMenuReportes" to="/reportes/activofijo">
                        <v-icon>mdi-circle-small</v-icon>Reportes de Activo Fijo
                    </app-bar-item>
                    <app-bar-item @click.native="hideMenuReportes" to="/reportes/etiquetas_activofijo">
                        <v-icon>mdi-circle-small</v-icon>Etiquetado Código QR
                    </app-bar-item>
                </v-list>
            </v-menu>
            <v-menu v-if="valida_permiso('af.nacional') && view_trafico==0 && view_costing==0 && af_nacional" open-on-hover offset-x nav transition="scale-transition">
                <template v-slot:activator="{ attrs, on }">

                    <span v-on="on" id="menuPermisosPrevios">
                        <app-bar-item @click.native="hideMenuReportes">

                            <v-icon>mdi-circle-small</v-icon><span style="text-transform: capitalize!important;">Activo Fijo Nacional</span>
                            <v-icon>mdi-menu-right</v-icon>
                        </app-bar-item>
                    </span>
                </template>
                <v-list :tile="false" nav>
                    <app-bar-item @click.native="hideMenuReportes" to="/reportes/af_nacional">
                        <v-icon>mdi-circle-small</v-icon>Información de Compras Nacionales
                    </app-bar-item>
                    <v-divider />
                    <app-bar-item @click.native="hideMenuReportes" to="/reportes/facturas_afn">
                        <v-icon>mdi-circle-small</v-icon>Consultar Facturas
                    </app-bar-item>
                    <app-bar-item @click.native="hideMenuReportes" to="/reportes/qr_af_nacional">
                        <v-icon>mdi-circle-small</v-icon>Etiquetado Código QR
                    </app-bar-item>
                </v-list>
            </v-menu>
            <v-divider />
            <v-menu v-if="sub_menu_indicadores && view_trafico==0" open-on-hover offset-x nav transition="scale-transition">
                <template v-slot:activator="{ attrs, on }">
                    <span v-on="on" id="menuIndicadoresEEA">
                        <app-bar-item>

                            <v-icon>mdi-circle-small</v-icon>Indicadores EEA<v-icon>mdi-menu-right</v-icon>

                        </app-bar-item>
                    </span>
                </template>

                <v-list :tile="false" nav>

                    <app-bar-item v-if="valida_permiso('eDrive.Indicadores.EEA.bitacora')" @click.native="hideMenuReportes" to="/vucem/bitacora_ws" @click.shift="openNew('/vucem/bitacora_ws');">

                        <v-icon>mdi-circle-small</v-icon>Bitácora

                    </app-bar-item>
                    <app-bar-item v-if="valida_permiso('eDrive.Indicadores.EEA.diganostico')" @click.native="hideMenuReportes" to="/vucem/diagnosticovucem" @click.shift="openNew('/vucem/diagnosticovucem');">

                        <v-icon>mdi-circle-small</v-icon>Diagnóstico

                    </app-bar-item>
                    <app-bar-item v-if="valida_permiso('eDrive.Indicadores.EEA.diganostico')" @click.native="hideMenuReportes" to="/vucem/documents_creados" @click.shift="openNew('/vucem/documents_creados');">

                        <v-icon>mdi-circle-small</v-icon>Doc. PDF Creados

                    </app-bar-item>

                    <app-bar-item v-if="valida_permiso('eDrive.Indicadores.EEA.confronta')" @click.native="hideMenuReportes" to="/vucem/confronta_ws_ds" @click.shift="openNew('/vucem/confronta_ws_ds');">

                        <v-icon>mdi-circle-small</v-icon>Confronta DS vs WS

                    </app-bar-item>

                    <app-bar-item v-if="valida_permiso('eDrive.Indicadores.EEA.recuperaciones')" @click.native="hideMenuReportes" to="/edrive/explorer_peticiones" @click.shift="openNew('/edrive/explorer_peticiones');">

                        <v-icon>mdi-circle-small</v-icon>Descarga de Evidencias

                    </app-bar-item>

                </v-list>
            </v-menu>
            <v-menu v-if="sub_menu_indicadores && view_trafico==0" open-on-hover offset-x nav transition="scale-transition">
                <template v-slot:activator="{ attrs, on }">
                    <span v-on="on" id="menuIndicadoresR">
                        <app-bar-item>

                            <v-icon>mdi-circle-small</v-icon>Recuperaciones<v-icon>mdi-menu-right</v-icon>

                        </app-bar-item>
                    </span>
                </template>

                <v-list :tile="false" nav>

                    <app-bar-item v-if="valida_permiso('eDrive.Indicadores.EEA.recuperaciones')" @click.native="hideMenuReportes" to="/vucem/recuperacionesws" @click.shift="openNew('/vucem/recuperacionesws');">

                        <v-icon>mdi-circle-small</v-icon>Documentos Importador Exportador

                    </app-bar-item>
                    <app-bar-item v-if="valida_permiso('eDrive.Indicadores.EEA.recuperaciones')" @click.native="hideMenuReportes" to="/recuperaciones_patente" @click.shift="openNew('/edrive/recuperaciones_patente');">

                        <v-icon>mdi-circle-small</v-icon>Documentos por Patente

                    </app-bar-item>
                    <app-bar-item v-if="valida_permiso('eDrive.Indicadores.EEA.recuperaciones')" @click.native="hideMenuReportes" to="/vucem/evidencias" @click.shift="openNew('/vucem/evidencias');">

                        <v-icon>mdi-circle-small</v-icon>Evidencias VUCEM

                    </app-bar-item>

                </v-list>
            </v-menu>
        </v-list>
    </v-menu>

    <!-- Reportes -->
    <v-menu bottom offset-y origin="center center" nav transition="scale-transition" v-if="es_analytics && !soloSoluciona && !soloSoluciona24">
        <template v-slot:activator="{ attrs, on }">
            <v-btn text v-on="on" :icon="fullWidth <= 1024" :title="fullWidth < 1024?'Reportes':''" v-tippy>
                <v-icon>file_copy</v-icon>
                <span class="caption" v-show="fullWidth > 1024">Reportes</span>
            </v-btn>
        </template>
        <v-list :tile="false" nav>

            <app-bar-item v-if="valida_permiso('REPORTES.predeterminados.ds') && view_trafico==0 && view_costing==0" to="/predeterminados" @click.shift="openNew('/predeterminados');">
                <v-icon>mdi-circle-small</v-icon>Predeterminados DS
            </app-bar-item>

            <app-bar-item v-if="valida_permiso('REPORTES.predeterminados.ws') && view_trafico==0 && view_costing==0" to="/predeterminadosws" @click.shift="openNew('/predeterminadosws');">
                <v-icon>mdi-circle-small</v-icon>Predeterminados WS
            </app-bar-item>

            <app-bar-item v-if="valida_permiso('REPORTES.rectificaciones') && view_trafico==0 && view_costing==0" to="/rectificaciones" @click.shift="openNew('/rectificaciones');">
                <v-icon>mdi-circle-small</v-icon>Rectificaciones
            </app-bar-item>



            <v-menu v-if="(valida_permiso('REPORTES.analiticos') || valida_permiso('DATA.STAGE.analiticos')) && view_trafico==0 && view_costing==0" open-on-hover offset-x nav transition="scale-transition">
                <template v-slot:activator="{ attrs, on }">

                    <span v-on="on" id="menuPermisosPrevios">
                        <app-bar-item @click.native="hideMenuReportes">

                            <v-icon x-small>mdi-check-decagram</v-icon>&nbsp; Analíticos Gráficos
                            <v-icon>mdi-menu-right</v-icon>
                        </app-bar-item>
                    </span>
                </template>
                <v-list :tile="false" nav>
                    <app-bar-item v-if="valida_permiso('REPORTES.analiticos')" @click.native="hideMenuReportes" to="/graficas/contribuciones">
                        <v-icon>mdi-circle-small</v-icon>Contribuciones
                    </app-bar-item>
                    <app-bar-item v-if="valida_permiso('DATA.STAGE.analiticos')" @click.native="hideMenuReportes" to="/graficas/pedimentos_patentes_ds">
                        <v-icon>mdi-circle-small</v-icon>Aduana - Patente DS
                    </app-bar-item>
                    <app-bar-item v-if="valida_permiso('REPORTES.analiticos')" @click.native="hideMenuReportes" to="/graficas/pedimentos_patentes">
                        <v-icon>mdi-circle-small</v-icon>Aduana - Patente WS
                    </app-bar-item>
                    <app-bar-item v-if="valida_permiso('REPORTES.analiticos')" @click.native="hideMenuReportes" to="/graficas/pedimentos_transportes">
                        <v-icon>mdi-circle-small</v-icon>Medios de Transporte WS
                    </app-bar-item>
                </v-list>
            </v-menu>

            <app-bar-item v-if="valida_permiso('REPORTES.rectificaciones') && view_trafico==0 && view_costing==0" to="/vucem/operaciones_virtuales" @click.shift="openNew('/vucem/operaciones_virtuales');">
                <v-icon>mdi-circle-small</v-icon>Operaciones Virtuales
            </app-bar-item>



            <v-menu v-if="(valida_permiso('REPORTES.permisosprevios') || valida_permiso('DATA.STAGE.permisos.previos.registros')) && view_trafico==0 && view_costing==0" open-on-hover offset-x nav transition="scale-transition">
                <template v-slot:activator="{ attrs, on }">

                    <span v-on="on" id="menuPermisosPrevios">
                        <app-bar-item @click.native="hideMenuReportes">

                            <v-icon>mdi-circle-small</v-icon><span style="text-transform: capitalize!important;">Permisos Previos</span>
                            <v-icon>mdi-menu-right</v-icon>
                        </app-bar-item>
                    </span>
                </template>
                <v-list :tile="false" nav>
                    <app-bar-item v-if="valida_permiso('DATA.STAGE.permisos.previos.registros')" @click.native="hideMenuReportes" to="/permisos_previos/reporteds">
                        <v-icon>mdi-circle-small</v-icon>Registros DS - Permisos
                    </app-bar-item>

                    <app-bar-item v-if="(valida_permiso('REPORTES.permisosprevios') ) " @click.native="hideMenuReportes" to="/permisos_previos/nuevo_permiso">
                        <v-icon>mdi-circle-small</v-icon>Consulta Permisos y Movimientos
                    </app-bar-item>
                </v-list>
            </v-menu>

            <v-menu v-if="(valida_permiso('REPORTES.cuentasaduaneras') || valida_permiso('DATA.STAGE.cuentas.aduaneras')) && view_trafico==0 && view_costing==0" open-on-hover offset-x nav transition="scale-transition">
                <template v-slot:activator="{ attrs, on }">
                    <span v-on="on" id="menuCuentasAduaneras">
                        <app-bar-item @click.native="hideMenuReportes">
                            <v-icon>mdi-circle-small</v-icon><span style="text-transform: capitalize!important;">Cuentas Aduaneras de Garantía</span>
                            <v-icon>mdi-menu-right</v-icon>

                        </app-bar-item>
                    </span>
                </template>
                <v-list :tile="false" nav>
                    <app-bar-item v-if="valida_permiso('REPORTES.cuentasaduaneras')" @click.native="hideMenuReportes" to="/reportes_cuentas_aduaneras/cuentasWS">
                        <v-icon>mdi-circle-small</v-icon>Cuentas Aduaneras WS
                    </app-bar-item>
                    <app-bar-item v-if="valida_permiso('DATA.STAGE.cuentas.aduaneras')" @click.native="hideMenuReportes" to="/reportes_cuentas_aduaneras/cuentasDS">
                        <v-icon>mdi-circle-small</v-icon>Cuentas Aduaneras DS
                    </app-bar-item>
                </v-list>
            </v-menu>
            <app-bar-item v-if="valida_permiso('REPORTES.predeterminados.ws') && view_trafico==0 && view_costing==0" to="/reportes/identificadores_complementos" @click.shift="openNew('/reportes/identificadores_complementos');">
                <v-icon>mdi-circle-small</v-icon>Identificadores y Complementos
            </app-bar-item>
             <app-bar-item v-if="false && valida_permiso('VUCEM.Pedimento.linea.captura') && view_trafico==0 && view_costing==0" to="/vucem/auditoria_lineas" @click.shift="openNew('/vucem/auditoria_lineas');">
                <v-icon>mdi-circle-small</v-icon>Auditoria Lineas de Captura Soia
            </app-bar-item>

            <v-divider v-if="valida_permiso('REPORTES.personalizados.administracion') && view_trafico==0 && view_costing==0 && is_cliente" />

            <v-menu v-if="(valida_permiso('REPORTES.personalizados.administracion') || valida_permiso('Anexo24.reportes')) && view_trafico==0 && view_costing==0 " open-on-hover offset-x nav transition="scale-transition">
                <template v-slot:activator="{ attrs, on }">
                    <span v-on="on" id="menuPersonalizados">
                        <app-bar-item @click.native="hideMenuReportes">
                            <v-icon x-small>mdi-check-decagram</v-icon><span style="text-transform: capitalize!important;">&nbsp; Personalizados</span>
                            <v-icon>mdi-menu-right</v-icon>
                        </app-bar-item>
                    </span>
                </template>
                <v-list :tile="false" nav>

                    <app-bar-item v-if="menu_especiales" @click.native="hideMenuReportes" to="/reportes/especiales">
                        <v-icon>mdi-circle-small</v-icon>Reportes Especiales
                    </app-bar-item>

                    <app-bar-item v-if="is_cliente_agrocentro" to="/reportes/rpt_layout_agrocentro" @click.native="hideMenuReportes" @click.shift="openNew('/reportes/rpt_layout_agrocentro');">
                        <v-icon>mdi-circle-small</v-icon>Consulta Exportaciones Nacionales
                    </app-bar-item>

                    <app-bar-item v-if="valida_permiso('Reportes.personalizados.referencias')" @click.native="hideMenuReportes" to="/catalogos/pedimento_referencia" @click.shift="openNew('/catalogos/pedimento_referencia');">
                        <v-icon>mdi-circle-small</v-icon>Layout-ID Planta-Referencia
                    </app-bar-item>

                    <app-bar-item v-if="is_cliente_bosch" to="/reportes/etiquetas_bosch" @click.native="hideMenuReportes" @click.shift="openNew('/reportes/etiquetas_bosch');">
                        <v-icon>mdi-circle-small</v-icon>Etiquetas AF Código QR
                    </app-bar-item>

                    <app-bar-item v-if="is_cliente_bosch" to="/reportes/contribuciones" @click.native="hideMenuReportes" @click.shift="openNew('/reportes/contribuciones');">
                        <v-icon>mdi-circle-small</v-icon>Reporte de Contribuciones
                    </app-bar-item>

                    <app-bar-item v-if="is_cliente_balluf" to="/reportes/consolidado_balluf" @click.native="hideMenuReportes" @click.shift="openNew('/reportes/consolidado_balluf');">
                        <v-icon>mdi-circle-small</v-icon>Reporte Freight Allocation
                    </app-bar-item> 

                    <app-bar-item v-if="is_cliente_balluf" to="/reportes/rpt_facturas_balluf" @click.native="hideMenuReportes" @click.shift="openNew('/reportes/rpt_facturas_balluf');">
                        <v-icon>mdi-circle-small</v-icon>Reporte de Facturas
                    </app-bar-item> 

                    <app-bar-item v-if="is_cliente_armado24" to="/reportes/armado_a24" @click.native="hideMenuReportes" @click.shift="openNew('/reportes/armado_a24');">
                        <v-icon>mdi-circle-small</v-icon>Armado Anexo 24
                    </app-bar-item>

                    <app-bar-item v-if="is_cliente_iewc" to="/reportes/iewc_armado_a24" @click.native="hideMenuReportes" @click.shift="openNew('/reportes/iewc_armado_a24');">
                        <v-icon>mdi-circle-small</v-icon>Armado Anexo 24
                    </app-bar-item>

                    <!-- <app-bar-item   @click.native="linkConsultaA24"> -->
                    <app-bar-item v-if="valida_permiso('Anexo24.reportes') && this.$local_storage.get('rfc') != 'RBT890331213'" @click.native="hideMenuReportes" to="/reportes/a24" @click.shift="openNew('/reportes/a24');">
                        <v-icon>mdi-circle-small</v-icon>Reportes Anexo 24
                    </app-bar-item>

                    <!-- NO SE AGREGA AL MENU HASTA QUE LO REVISEN EN ECONNECT--> 
                    <app-bar-item v-if="(is_cliente_magna || is_cliente_rbt || is_cliente_arneses || is_cliente_bosch || is_cliente_sanoh)" to="/reportes/layout_proforma" @click.native="hideMenuReportes" @click.shift="openNew('/reportes/layout_proforma');">
                        <v-icon>mdi-circle-small</v-icon>Generador Factura Proforma
                    </app-bar-item>

                    <app-bar-item v-if="is_cliente_identificadores" to="/reportes/aam_identificadores" @click.native="hideMenuReportes" @click.shift="openNew('/reportes/aam_identificadores');">
                        <v-icon>mdi-circle-small</v-icon>Identificadores y Complementos
                    </app-bar-item>

                    <app-bar-item v-if="is_cliente_identificadores_auditoria" to="/reportes/identificadores_auditoria" @click.native="hideMenuReportes" @click.shift="openNew('/reportes/identificadores_auditoria');">
                        <v-icon>mdi-circle-small</v-icon>Reporte General de Mercancías Asociadas a Identificadores
                    </app-bar-item>
                    <app-bar-item v-if="is_cliente_identificadores_auditoria" to="/reportes/auditoria_rrna" @click.native="hideMenuReportes" @click.shift="openNew('/reportes/identificadores_auditoria');">
                        <v-icon>mdi-circle-small</v-icon>Reporte de Auditoría RRNA
                    </app-bar-item>

                    <app-bar-item v-if="is_cliente_yazaki" to="/reportes/rpt_preferencias" @click.native="hideMenuReportes" @click.shift="openNew('/reportes/rpt_preferencias');">
                        <v-icon>mdi-circle-small</v-icon>Preferencias Arancelarias
                    </app-bar-item>
                    
                </v-list>

                <!-- personalizados a24 -->
            </v-menu>
            <v-menu v-if="is_cliente_bosch" open-on-hover offset-x nav transition="scale-transition">
                <template v-slot:activator="{ attrs, on }">
                    <span v-on="on" id="menuPersonalizados2">
                        <app-bar-item @click.native="hideMenuReportes">
                            <v-icon x-small>mdi-check-decagram</v-icon><span style="text-transform: capitalize!important;">&nbsp; Personalizados A24</span>
                            <v-icon>mdi-menu-right</v-icon>
                        </app-bar-item>
                    </span>
                </template>
                <v-list :tile="false" nav>

                   

                    <app-bar-item v-if="is_cliente_bosch" to="/reportes/rpt_layout_bosch" @click.native="hideMenuReportes" @click.shift="openNew('/reportes/rpt_layout_bosch');">
                        <v-icon>mdi-circle-small</v-icon>Descargo de Observaciones
                    </app-bar-item>

                    <app-bar-item v-if="is_cliente_bosch" to="/reportes/rpt_layout2_bosch" @click.native="hideMenuReportes" @click.shift="openNew('/reportes/rpt_layout2_bosch');">
                        <v-icon>mdi-circle-small</v-icon>Consulta BOM
                    </app-bar-item>
                    <app-bar-item v-if="is_cliente_bosch" to="/reportes/rpt_cruce_bosch" @click.native="hideMenuReportes" @click.shift="openNew('/reportes/rpt_cruce_bosch');">
                        <v-icon>mdi-circle-small</v-icon>Analisis de Descargo vs BOM
                    </app-bar-item>
                  
                </v-list>

                <!-- utilerias/cargaa24 -->
            </v-menu>
            <v-divider v-if="is_cliente && es_analytics" />
            <app-bar-item v-if="!Admin && es_analytics" to="/catalogos/etipsHTML" @click.shift="openNew('/catalogos/etipsHTML');">
                <v-icon>mdi-circle-small</v-icon>Manual de Usuario 
            </app-bar-item>

            <app-bar-item v-if="!Admin && es_analytics" to="/videotutorial" @click.shift="openNew('/videotutorial');">

                <v-icon>mdi-circle-small</v-icon>Video Tutoriales 

            </app-bar-item>

        </v-list>
    </v-menu>

</div>
</template>

<script>
// Components
import {
    VHover,
    VListItem
} from "vuetify/lib";

// Utilities
import {
    mapState,
    mapMutations
} from "vuex";

import Util from "@/util";
import axios from "axios";

export default {
    name: "menuAnalitics",

    created() {

        this.$local_storage.set("es_emanifiesto_logistico", this.$local_storage.get("EmanifiestoMV.bitacora") == 100);

    },
    components: {

        AppBarItem: {
            render(h) {
                return h(VHover, {
                    scopedSlots: {
                        default: ({
                            hover
                        }) => {
                            return h(
                                VListItem, {
                                    attrs: this.$attrs,
                                    class: {
                                        "black--text": !hover,
                                        "white--text secondary elevation-12": hover
                                    },
                                    props: {
                                        activeClass: "",
                                        dark: hover,
                                        link: true,
                                        ...this.$attrs
                                    }
                                },
                                this.$slots.default
                            );
                        }
                    }
                });
            }
        }
    },

    props: {
        value: {
            type: Boolean,
            default: false
        }
    },

    data: () => ({
        fab: false,

        show_loading: false,
        notificationsNumber: 0,
        show: true,
        rfc: "",
        razon: "",
        tipo_usuario: "",
        id_cliente: 0,
        minifiedLeft: false,
        hiddenLeft: false,
        avatar: "undefined",
        fullWidth: document.documentElement.clientWidth,
        notifications: [
            "Mike John Responded to your email",
            "You have 5 new tasks",
            `You're now friends with Andrew`,
            "Another Notification",
            "Another one"
        ]
    }),

    computed: {
        ...mapState(["drawer"]),
        view_trafico() {
            return this.$store.state.trafico;
        },
        view_costing() {
            return this.$store.state.costing;
        },
        view_emanifiesto() {
            return this.$store.state.emanifiesto;
        },
        view_carta_porte() {
            return this.$store.state.carta_porte;
        },
        view_sa31() {
            return this.$store.state.sa31;
        },
        view_sa24() {
            return this.$store.state.sa24;
        },
        toolbarColor() {
            return this.$vuetify.options.extra.mainNav;
        },
        
        af_nacional() {
            return  this.$local_storage.get("Modulo17") == 100 ;
        },
        soloEcosting() {
            return this.$local_storage.get("DATA.STAGE.bitacora") != 100 && this.$local_storage.get("VUCEM.Transmision.nuevo.cove") != 100 && this.$local_storage.get("Reportes.ecosting.consulta.facturas") == 100;
        },
        soloEmanifiesto() {
            return this.$local_storage.get("DATA.STAGE.bitacora") != 100 &&
                this.$local_storage.get("VUCEM.Transmision.nuevo.cove") != 100 &&
                this.$local_storage.get("Reportes.ecosting.consulta.facturas") != 100 &&
                this.$local_storage.get("EmanifiestoCP.bitacora") == 100  &&
                (this.$local_storage.get("EmanifiestoMV.bitacora") == 100) && this.$local_storage.get("Modulo18") != 100;
        },
        es_transportista() {
            return this.$local_storage.get("es_transportista") == 1;
        },
        es_analytics() {
            return this.view_costing == 0 &&
                this.view_emanifiesto == 0 &&
                this.view_sa31 == 0 &&
                this.view_sa24 == 0 &&
                this.view_carta_porte == 0 && 
                this.view_trafico == 0 &&
                this.$local_storage.get("id_cliente") > 0 && this.$local_storage.get("Modulo14") != 100 && (this.$local_storage.get("Modulo6") == 100 ||  this.$local_storage.get("Modulo2") == 100 || this.$local_storage.get("Modulo3") == 100) ;
        },
        soloSoluciona() {
            return this.$local_storage.get("DATA.STAGE.bitacora") != 100 && this.$local_storage.get("VUCEM.Transmision.nuevo.cove") != 100
            && this.$local_storage.get("Reportes.ecosting.consulta.facturas") != 100 && this.$local_storage.get("EmanifiestoCP.bitacora") != 100 &&
            this.$local_storage.get("EmanifiestoAA.edrive.consultar") != 100 &&  this.$local_storage.get("Modulo6") != 100 &&
             (this.$local_storage.get("EmanifiestoMV.bitacora") != 100 ) && this.$local_storage.get( "Logistica.nuevoregistro" ) != 100
             && (this.$local_storage.get("Modulo15") == 100 || this.$local_storage.get("Modulo16") == 100) && this.$local_storage.get("Modulo18") != 100;
        },
        soloSoluciona24() {
            return this.$local_storage.get("DATA.STAGE.bitacora") != 100 && this.$local_storage.get("VUCEM.Transmision.nuevo.cove") != 100
            && this.$local_storage.get("Reportes.ecosting.consulta.facturas") != 100 && this.$local_storage.get("EmanifiestoCP.bitacora") != 100 &&
            this.$local_storage.get("EmanifiestoAA.edrive.consultar") != 100  && this.$local_storage.get("Modulo6") != 100 &&
             (this.$local_storage.get("EmanifiestoMV.bitacora") != 100 ) && this.$local_storage.get( "Logistica.nuevoregistro" ) != 100
             && this.$local_storage.get("Modulo15") != 100 && this.$local_storage.get("Modulo16") != 100 && this.$local_storage.get("Modulo18") == 100;
        },
        rfc_transportista() {
            return this.$local_storage.get("rfc_grupo");;
        },
        Admin() {
            return (
                this.$local_storage.get("tipo_usuario") == "Super Usuario" &&
                this.$local_storage.get("id_cliente") == 0
            );
        },
        Super() {
            return (
                this.$local_storage.get("tipo_usuario") == "Super Usuario" 
            );
        },
        Legal() {
            return (this.$local_storage.get("tipo_usuario") == "Asuntos Legales");
        },
        Pagos() {
            return (this.$local_storage.get("tipo_usuario") == "Pagos");
        },
        soloCartaPorte() {
            return (this.$local_storage.get("soloCartaPorte") == 100);
        },
        menu_catalogos() {
            return (
                this.$local_storage.get("id_cliente") > 0 &&
                (
                    this.valida_permiso("catalogos.emisores") ||
                    this.valida_permiso("catalogos.embarques") ||
                    this.valida_permiso("catalogos.transportistas") ||
                    this.valida_permiso("catalogos.agentes") ||
                    this.valida_permiso("catalogos.representantes") ||
                    this.valida_permiso("catalogos.agentes") ||
                    this.valida_permiso("catalogos.bancos") ||
                    this.valida_permiso("catalogos.mercancias")
                )
            );
        },
        menu_utilerias() {
            return (
                this.$local_storage.get("id_cliente") > 0 &&
                (
                    this.valida_permiso("administracion.usuarios") ||
                    this.valida_permiso("administracion.aduanas") ||
                    this.valida_permiso("administracion.apendices") ||
                    this.valida_permiso("administracion.logistica.estados") ||
                    this.valida_permiso("administeacion.logistica.columnas") ||
                    this.valida_permiso("administracion.logistica.plantillas") ||
                    this.valida_permiso("administracion.log") ||
                    this.valida_permiso("administracion.accesos") ||
                    this.valida_permiso("administracion.enotes") ||
                    this.valida_permiso("administracion.indicadores") ||
                    this.valida_permiso("Anexo24.reportes") ||
                    this.valida_permiso("administracion.configurables")

                ) && this.view_emanifiesto == 0 && this.view_carta_porte == 0
            );
        },

        menu_transmision() {
            return (
                this.$local_storage.get("id_cliente") > 0 &&
                (
                    this.valida_permiso("VUCEM.Transmision.nuevo.cove") ||
                    this.valida_permiso("VUCEM.Transmision.ver.coves") ||
                    this.valida_permiso("VUCEM.Transmision.nuevo.edocument") ||
                    this.valida_permiso("VUCEM.Transmision.ver.edocument") ||
                    this.valida_permiso("VUCEM.Transmision.reporte.coves") ||
                    this.valida_permiso("VUCEM.Transmision.reporte.edocument")
                ) && this.view_carta_porte == 0
            );
        },

        menu_datastage() {
            return (
                this.$local_storage.get("id_cliente") > 0 &&
                (
                    this.valida_permiso("DATA.STAGE.cargazip") ||
                    this.valida_permiso("DATA.STAGE.bitacora") ||
                    this.valida_permiso("DATA.STAGE.reportes.directos")
                ) && this.view_carta_porte == 0
            );
        },
        menu_vucem() {
            return (
                this.$local_storage.get("id_cliente") > 0 &&
                (
                    this.valida_permiso("VUCEM.Pedimento.solicitud.consulta") ||
                    this.valida_permiso("VUCEM.Pedimento.consulta.diaria") ||
                    this.valida_permiso("VUCEM.Pedimento.consulta.soia") ||
                    this.valida_permiso("VUCEM.Pedimento.linea.captura") ||
                    this.valida_permiso("VUCEM.Pedimento.consulta.pedimento") ||
                    this.valida_permiso("VUCEM.Pedimento.consulta.cove") ||
                    this.valida_permiso("VUCEM.Pedimento.consulta.edocument") ||
                    this.valida_permiso("VUCEM.Pedimento.consulta.acuses") ||
                    this.valida_permiso("VUCEM.Pedimento.consulta.estado") ||
                    this.valida_permiso("VUCEM.Pedimento.reportes.directos")
                ) && this.view_carta_porte == 0
            );
        },
        menu_edrive() {
            return (
                this.$local_storage.get("id_cliente") > 0 &&
                (
                    this.valida_permiso("eDrive.consulta.expediente") ||
                    this.valida_permiso("eDrive.descargar.expediente") ||
                    this.valida_permiso("eDrive.carga.zip") ||
                    this.valida_permiso("eDrive.consulta.adjuntos") ||
                    this.valida_permiso("eDrive.activofijo") ||
                    this.sub_menu_indicadores
                ) && this.view_carta_porte == 0
            );
        },

        is_consignatario() {
            return this.$local_storage.get("perfil_grupo") == 43;
        },
        sub_menu_indicadores() {
            return (
                this.$local_storage.get("id_cliente") > 0 &&
                (
                    this.valida_permiso("eDrive.Indicadores.EEA.bitacora") ||
                    this.valida_permiso("eDrive.Indicadores.EEA.diganostico") ||
                    this.valida_permiso("eDrive.Indicadores.EEA.confronta") ||
                    this.valida_permiso("eDrive.Indicadores.EEA.recuperaciones")
                )
            );
        },

        is_cliente() {
            return (
                this.$local_storage.get("id_cliente") > 0
            );
        },
        is_cliente_bosch() {
            return (
                this.$local_storage.get("id_cliente") > 0 && this.$local_storage.get("rfc") == "RBS980129FQ5" 
            );
        },
        is_cliente_agrocentro() {
            return (
                this.$local_storage.get("id_cliente") > 0 && this.$local_storage.get("rfc") == "ACA900823GK6" 
            );
        },        
        is_cliente_balluf() {
            return (
                this.$local_storage.get("id_cliente") > 0 && this.$local_storage.get("rfc") == "BMA2211187E1"
            );
        },
        is_cliente_armado24() {
            return (
                this.$local_storage.get("id_cliente") > 0 && ["SME1302011P5","TRM150601MA7","SAK960514KC5","TFE951129F12", "AEM000515F97" , "MMI910827JY5", "PCI890511DY0", "NMP140226GW3", "SIM900831LS2", "LAE141126MI4","VMA050218KE2","GTA200109CE5","RPA040310JS2","SME981015CA8","ASC120201GH3"].includes(this.$local_storage.get("rfc"))

            );
        },
        is_cliente_iewc() {
            return (
                this.$local_storage.get("id_cliente") > 0 && this.$local_storage.get("rfc") == "IME0410149J6"
            );
        },
        is_cliente_magna() {
            return (
                this.$local_storage.get("id_cliente") > 0 && this.$local_storage.get("rfc") == "MSM0311078M4"
            );
        },
        is_cliente_rbt() {
            return (
                this.$local_storage.get("id_cliente") > 0 && this.$local_storage.get("rfc") == "RBT890331213"
            );
        },
        is_cliente_sanoh(){
            return(this.$local_storage.get("id_cliente") > 0 && this.$local_storage.get("rfc") == "SIM900831LS2")
        },
        is_cliente_saturno(){
            return(this.$local_storage.get("id_cliente") > 0 && this.$local_storage.get("rfc") == "SME981015CA8")
        },
        is_cliente_steel(){
            return(this.$local_storage.get("id_cliente") > 0 && this.$local_storage.get("rfc") == "ASC120201GH3")
        },
        is_cliente_arneses() {
            return (
                this.$local_storage.get("id_cliente") > 0 && this.$local_storage.get("rfc") == "SAK960514KC5"
            );
        },
        is_cliente_identificadores() {
            return (
                this.$local_storage.get("id_cliente") > 0 && ["AMM060130M44","AAM9712016M2","MSC990408KV1","MSC9910255Y4"].includes(this.$local_storage.get("rfc"))
            );
        },
        is_cliente_identificadores_auditoria() {
            return (
                this.$local_storage.get("id_cliente") > 0 && ["IAI100609SRA"].includes(this.$local_storage.get("rfc"))
            );
        },
        is_cliente_yazaki() {
            return (
                this.$local_storage.get("id_cliente") > 0 && ["ACC010328EQ6","PED781129JT6","YSE040623J42","ARN940318R57"].includes(this.$local_storage.get("rfc"))
            );
        },        

        menu_especiales() {
            let permitidos = ["BMC1803136P2", "DRA931201UBA", "CME9507123M7", "CPA150831D6A", "PMM1907275A1", "AWM080206HK0", "IEA1608162R8", "MER890428KI0",
                "ISM901130LRA", "KCO040707BB5", "SEM020410154", "CTJ860423AH0", "SEC8908244S6", "ZIN011230IY6", "ZNA520512A83", "TDM0101165P6", "ATO990618K58",
                "MME171108F3A", "TEK110318K47", "AMI971127190", "FTM1206155F0", "GME010313SS0", "ASP131121291", "CQU860221CH4", "CTC861104I92", "KLM860411MD2",
                "CES801003T12", "PRE820415237", "EAB9407041X0", "OAI131125GY0", "PHA9706159JA", "CMS981015BF0", "GMS980324LN4", "GSM920409JL6"
            ];
            return permitidos.indexOf(this.$local_storage.get("rfc")) >= 0;
        },
        menu_anexo24() {
            let rfcs = ["AEM000515F97", "PCI890511DY0", "MMI910827JY5"];
            return rfcs.indexOf(this.$local_storage.get("rfc")) >= 0 && this.$local_storage.get("tipo_usuario") == "Super Usuario";
        },
        esGrupo() {
            return this.$local_storage.get("panel_grupo") == 1 && this.$local_storage.get('grupo') > 0 && this.$local_storage.get("tipo_usuario") == "Grupo" && this.$local_storage.get("id_cliente") == 0;
        },

    },

    methods: {
        ...mapMutations({
            setDrawer: "SET_DRAWER"
        }),
        valida_permiso(permiso) {
            return (
                this.$local_storage.get(permiso) == 100 && this.$local_storage.get("id_cliente") > 0
            );
        },
        valida_permiso_t(permiso) {
            return (
                this.$local_storage.get(permiso) == 100
            );
        },
        linkConsultaRapida: function () {

            //   window.open("https://aplicacionesc.mat.sat.gob.mx/SOIANET/oia_consultarap_cep.aspx", "_blank");
            window.open("https://aplicacionesc.mat.sat.gob.mx/SOIA_CR_WEB/oia_consultarap_cep.aspx", "_blank");

        },
        linkConsultaA24: function () {
            let email = this.$local_storage.get("email");
            let link = "https://integra24.mx/A24/ReportesA24U?USU=" + email;
            window.open(link, "_blank");
        },

        openNew: function (h) {
            window.open(h, "_blank");
        },

        base64ToArrayBuffer: function (base64) {
            var binaryString = window.atob(base64);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
                var ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
            }
            return bytes;
        },
        downloadFile: function (key) {
            this.$root.$dialogLoader.show('Espere un momento por favor..');
            var datos = {
                id: key,
                bucket: "descargas.econnectpro.mx"
            }
            let nombre_download = key.split("/").pop();
            axios.post(this.$hostname + "s3/download/", datos, {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    Allow: "POST",
                    "cache-control": "no-cache",
                })
                .then(response => {
                    var bytes = this.base64ToArrayBuffer(response.data);
                    let blob = new Blob([bytes], {
                            type: response.headers["content-type"]
                        }),
                        url = window.URL.createObjectURL(blob);

                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = url;
                    a.download = nombre_download;
                    a.click();
                    a.parentNode.removeChild(a);
                })
                .catch(error => {
                    console.log(error);

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });

        },
        hideMenuReportes: function () {

            var menu = document.getElementById("menuPermisosPrevios");
            var menu2 = document.getElementById("menuCuentasAduaneras");
            var menu3 = document.getElementById("menuIndicadoresEEA");
            var menu5 = document.getElementById("menuSoia");
            var menu6 = document.getElementById("menuEstados");

            if (menu) {
                menu.click();
            }
            if (menu6) {
                menu6.click();
            }

            if (menu2) {
                menu2.click();
            }

            if (menu3) {
                menu3.click();
            }
            if (menu5) {
                menu5.click();
            }
        },
    },

};
</script>

<style scoped>
.v-menu__content .v-list--nav .v-list-item {
    padding-top: 0px;
    padding-bottom: 0px;
    padding-left: 5px;
    text-decoration: none;
}

.v-sheet button.v-btn.v-size--default:not(.v-btn--icon):not(.v-btn--fab) {
    padding-left: 10px !important;
}
</style>
